import { useEffect, useRef } from "react";

// IntersectionObserver-based scroll reveal. Applies "is-visible" class on entry.
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => entry.target.classList.add("is-visible"), delay);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${className}`}>
            {children}
        </Tag>
    );
}
